import React, {useState} from 'react';
import {connect} from "react-redux";
import ContactEditPhoneRow from "./components/contact-edit-phone-row";

function ContactEditPhoneRows (props) {

    const {findContactDetails} = props;

    let uniqId = 0;

    let defaultPhoneNumberRows = [{
        "id": "0",
        "label":"",
        "number":""
    }];

    if(findContactDetails.phoneContactEntry.phoneNumbers){
        defaultPhoneNumberRows = findContactDetails.phoneContactEntry.phoneNumbers.map(item => {
            uniqId++;
            return {
                id: uniqId.toString(),
	            ...item,
            }
        })
    }

    const [phoneNumberRows, setPhoneNumbersRows] = useState(defaultPhoneNumberRows);

    const handleNewPhoneRow = () => {
        setPhoneNumbersRows([
            ...phoneNumberRows,
            {
                "id": (parseInt(phoneNumberRows[phoneNumberRows.length - 1].id, 10) + 1).toString(),
                "label":"",
                "number":""
            }
        ])
    };

    const handleDeletePhoneRow = (e) => {
        setPhoneNumbersRows(phoneNumberRows.filter((phoneNumberRow, index) => parseInt(e.currentTarget.dataset.index, 10) !== index));
    };

    return (
        <div className="border-top py-3">
            {
                phoneNumberRows.map((phoneNumberRow, index) => (
                    <ContactEditPhoneRow
                        key={phoneNumberRow.id}
                        phoneNumber={phoneNumberRow}
                        index={index}
                        newPhoneRow={handleNewPhoneRow}
                        deletePhoneRow={handleDeletePhoneRow}
                    />
                ))
            }
        </div>
    )

}

const mapStateToProps = (state) => {
    return {
        findContactDetails: state.contactDetailsReducer.findContactDetails,
    }
};

export default connect(mapStateToProps)(ContactEditPhoneRows);